import { useMemo } from 'react'
import styled from '@emotion/styled'
import { useScreen } from '../../utils/responsive-helper'
import { ExerciseHistoryCard } from './component'
import Headbar from '../../components/common/HeadBar'
import * as paths from '../../constant/path'
import Tabs from '../../components/common/Tabs'
import colors from '../../constant/colors'
import { UserClaimList, EClaimHistory as EClaimHistoryType, EClaimStatus } from '../../services/e-claim/e-claim-types'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useGetExerciseHistoryList } from '../../services/exercise/exercise-query'

const Layout = styled.div`
  margin-bottom: 40px;
`
const ContentLayout = styled.div`
  background-color: ${colors.WHITE};
  padding: 16px;
  border-radius: 16px;
  min-height: 500px;
`
const ExerciseCardLayout = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`

type ExerciseHistoryPageProps = {
  data: EClaimHistoryType
}
const ExerciseHistoryPage = (props: Partial<ExerciseHistoryPageProps>) => {
  const { data } = props

  return (
    <ExerciseCardLayout>
      {data?.userClaimList?.map((item: UserClaimList) => (
        <Link
          key={item.claimId}
          to={paths.exerciseHistoryDetail({ routeParam: { id: item.id } })}
        >
          <ExerciseHistoryCard data={item} status={data?.statusName} />
        </Link>
      ))}
    </ExerciseCardLayout>
  )
}

const ExerciseHistory = () => {
  const { isMobile } = useScreen()
  const { t } = useTranslation()
  const { data: ExerciseHistoryList } = useGetExerciseHistoryList()

  const dataSource = useMemo(() => {
    return [
      {
        name: t('eClaim.history.status.pending'),
        key: '0',
        page: <ExerciseHistoryPage data={ExerciseHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.UNAPPROVED)[0]} />,
      },
      {
        name: t('eClaim.history.status.cancel'),
        key: '1',
        page: <ExerciseHistoryPage data={ExerciseHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.CANCELED)[0]} />,
      },
      {
        name: t('eClaim.history.status.rejected'),
        key: '2',
        page: <ExerciseHistoryPage data={ExerciseHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.REJECTED)[0]} />,
      },
      {
        name: t('eClaim.history.status.approved'),
        key: '3',
        page: <ExerciseHistoryPage data={ExerciseHistoryList?.filter((item: EClaimHistoryType) => item.statusName === EClaimStatus.APPROVED)[0]} />,
      },
    ]
  }, [ExerciseHistoryList])

  return (
    <>
      <Layout style={{ paddingTop: '24px' }}>
        <Headbar title={t('eClaim.history.title')} backWard={paths.exercise()} titleColor={colors.BLACK} />
        <ContentLayout>
          <Tabs
            dataSource={dataSource}
            mode={isMobile ? 'select' : undefined}
          />
        </ContentLayout>
      </Layout>
    </>
  )
}
export default ExerciseHistory 